import { Link } from 'react-router-dom';

const guideLinks = [
  { label: 'Guida Completa 2026', slug: 'guida-itaobuy-spreadsheet' },
  { label: 'Sicurezza Acquisti', slug: 'sicurezza-acquisti-online' },
  { label: 'Guida Principianti', slug: 'guida-principianti' },
  { label: 'Migliori Prodotti', slug: 'migliori-prodotti-2026' },
  { label: 'Come Usare', slug: 'come-usare-itaobuy' },
  { label: 'Confronto Prezzi', slug: 'confronto-prezzi-qualita' },
  { label: 'QC Photos Guide', slug: 'qc-photos-guida-completa' },
  { label: 'Recensione 2026', slug: 'recensione-completa-2026' },
  { label: 'Categorie Prodotti', slug: 'guida-categorie-prodotti' },
  { label: 'Risparmiare', slug: 'risparmiare-acquisti-online' },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold text-foreground-950 mb-4">
              Itaobuy <span className="text-primary-500">Spreadsheet</span>
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Il tuo punto di riferimento italiano per Itaobuy Spreadsheet. Guide, recensioni e consigli per trovare i migliori prodotti online.
            </p>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-800 mb-4">Articoli e Guide</h5>
            <ul className="space-y-2">
              {guideLinks.map((link) => (
                <li key={link.slug}>
                  <Link to={`/articolo/${link.slug}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-800 mb-4">Categorie</h5>
            <ul className="space-y-2">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Scarpe</a></li>
              <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Felpe</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">T-Shirt</a></li>
              <li><a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Giacche</a></li>
              <li><a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Accessori</a></li>
              <li><a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Borse</a></li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-800 mb-4">Link Rapidi</h5>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Home</Link></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">itaobuy sheet</a></li>
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">buy it now</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © 2026 Itaobuy Spreadsheet Italia. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Home</Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Kaspreadsheet</a>
          </div>
        </div>
      </div>
    </footer>
  );
}